import { BatchesService } from '@festina/datamart-general-types/datamart/services/BatchesService'
import { useFestinaMutation } from '@festina-life/authentication'

const method = BatchesService.batchesServicePostCreate
type MethodParam = NonNullable<Parameters<typeof method>[0]['requestBody']>

export const useSubmitDatamartBatch = () =>
  useFestinaMutation({
    component: 'dataMart',
    roles: BatchesService.batchesServicePostCreate_roles,
    isScenario: false,
    mutateFunction: async (arg: MethodParam) => {
      await method({ requestBody: arg })
    },
  })
